"use strict";

var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");

var _Object$defineProperty = require("@babel/runtime-corejs3/core-js-stable/object/define-property");

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports.default = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/extends"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/objectWithoutProperties"));

var _react = _interopRequireDefault(require("react"));

var _classnames = _interopRequireDefault(require("classnames"));

var SvgShare = function SvgShare(_ref) {
  var svgRef = _ref.svgRef,
      props = (0, _objectWithoutProperties2.default)(_ref, ["svgRef"]);
  props.className = (0, _classnames.default)('Icon', props.className);
  return _react.default.createElement("svg", (0, _extends2.default)({
    viewBox: "0 0 1024 1024",
    fill: "currentColor",
    ref: svgRef
  }, props), _react.default.createElement("path", {
    d: "M856.6 511.2c-2.1-21.2-19.9-37.7-41.6-37.7-21.7 0-39.4 16.5-41.6 37.5v427.9H83.1V248.5h500.2c22.7 0 41.2-18.4 41.2-41.2s-18.4-41.2-41.2-41.2H24.4C11 166.1 0 177.1 0 190.6V998c0 13.5 10.9 24.4 24.4 24.4h807.4c13.5 0 24.4-10.9 24.4-24.4V511.2h.4zM1024 89L709 4.3c-4.1-1.7-8.9-2.7-13.8-2.7-22.6.6-40.6 19.1-40.6 41.7v.9c0 19.8 14.6 36.2 33.7 39h.2l166.2 44.9c-117.2 70-214.8 160.6-290.6 267.6-39.9 55.3-71.6 115.7-93.8 180.4l-6.2 21.8 78.8 22.8 5.1-16.5c21.4-61.2 49.6-114.2 84.3-162.1 69.7-97.8 158.5-179.8 261.1-241l-55.1 167.2c-1 3-1.8 6.5-2 10.1.4 22.7 18.7 40.8 41.3 40.8 16.5 0 30.6-9.6 37.3-23.5l.1-.2L1024 89z"
  }));
};

var ForwardRef = _react.default.forwardRef(function (props, ref) {
  return _react.default.createElement(SvgShare, (0, _extends2.default)({
    svgRef: ref
  }, props));
});

var _default = ForwardRef;
exports.default = _default;